import { moduleTypes } from 'common-src/models/PatientInteraction';

export const dataImportRangeOptions = [0, 5, 10, 15];

export const excludedModulesIds = [
  moduleTypes.Addendum.id,
  moduleTypes.CloseDiabetesAccount.id,
  moduleTypes.HoldRequest.id,
  moduleTypes.CloseCognitiveAccount.id,
];

export const EXCLUDED_IDS_FOR_LINKED_CONVERSATIONS = [moduleTypes.NeurologyEvaluation.id];

export const EXCLUDED_REQUIRED_QUESTION_IDS = ['summary-of-screening'];
